import { Transition } from '@uirouter/core';
import { ISCEService, IScope, ITimeoutService } from 'angular';
import { Action } from '../../common/actions/core/action';
import ActionDispatcherService from '../../common/actions/core/action-dispatcher.service';
import { ActionHandler } from '../../common/actions/core/action-handler';
import UtilService from '../../common/services/util.service';
import { MasterpassCardDeleteAction } from './masterpass-card-delete-dialog.action';
import GoogleAnalyticsService from '../../common/services/analytics/google-analytics.service';
import { DeleteCreditCardEvent } from '../../common/services/analytics/events/dimensions';
import { MasterCard } from '../services/payment-method.model';
import { MasterPassError } from '../../common/services/error/error.action';
import { MasterpassService } from '../services/masterpass.service';

/* @ngInject */
export default class MasterpassCardDeleteDialogController implements ActionHandler {
  private dialogElement;
  protected card: MasterCard;
  protected onDeleteSuccess: (cardName) => any;
  protected msisdnTr: string;

  constructor(
    private $element,
    private actionDispatcher: ActionDispatcherService,
    private $state,
    private $scope: IScope,
    private $timeout: ITimeoutService,
    private googleAnalytics: GoogleAnalyticsService,
    private config,
    private i18n,
    private masterpassService: MasterpassService
  ) {
    this.actionDispatcher.register(this);
  }

  public $postLink() {
    this.dialogElement = this.$element.find('#mastercard-delete-dialog').remodal();
  }

  public $onDestroy() {
    this.actionDispatcher.unregister(this);
    this.dialogElement.destroy();
  }

  public handle(action: Action) {
    if (action instanceof MasterpassCardDeleteAction) {
      window['MFS'].setClientId(this.config.masterpass.clientId);
      if(!!this.config.masterpass.address) {
        window['MFS'].setAddress(this.config.masterpass.address);
      }
      this.onDeleteSuccess = action.onDeleteSuccess;
      this.card = action.card;
      this.msisdnTr = action.msisdn;
      this.openDialog();
    }
  }

  public onClick() {
    this.close();
  }

  private openDialog() {
    this.$timeout(() => {
      this.dialogElement.open();
    });
  }

  public onCancel() {
    this.close();
  }

  private close() {
    this.dialogElement.close();
  }

  public onDelete() {
    this.masterpassService.isV2().then(isV2 => {
      if (isV2) {
        this.onDeleteV2();
        return;
      }

      this.onDeleteV1();
    });
  }

  private onDeleteV1() {
    $('[name=referenceNo]').val(UtilService.generateRandomNumber(999999999999));
    $('[name=msisdn]').val(this.msisdnTr);
    $('[name=sendSmsLanguage]').val(this.i18n.getCurrentLanguage() == 'en' ? 'eng' : 'tur');
    $('[name=accountAliasName]').val(this.card.Name);
    
    const masterToken = UtilService.getSessionStorageWithExpire("masterpass.token");
    if(!!masterToken) {
      $('[name=token]').val(masterToken);
      window['MFS'].deleteCard($('#delete-form'), this.mfsResponseHandler.bind(this));
    } else {
      this.masterpassService.getToken().then(token => {
        UtilService.setSessionStorageWithExpire("masterpass.token", token, 840000);
        $('[name=token]').val(token);
        window['MFS'].deleteCard($('#delete-form'), this.mfsResponseHandler.bind(this));
      });
    }
  }

  private onDeleteV2() {
    this.masterpassService.removeCard(this.msisdnTr, this.card.Name)
      .then(response => this.removeCardV2ResponseHandler(response))
      .catch(error => this.removeCardV2ResponseHandler(error));
  }

  private removeCardV2ResponseHandler(response: any) {
    if (response && !response.exception) {
      this.onDeleteSuccess(this.card.Name);
      return;
    }

    const exceptionCode = response && response.exception ? response.exception.code : null;
    const exceptionMessage = response && response.exception ? response.exception.message : null;
    this.actionDispatcher.dispatch(new MasterPassError(exceptionCode, exceptionMessage));
  }
  public mfsResponseHandler(status, response)
  {
    if (response.responseCode == "0000" || response.responseCode == "") {
      this.onDeleteSuccess(this.card.Name);
    } else {
      this.actionDispatcher.dispatch(new MasterPassError(response.responseCode, response.responseDescription));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/buy/masterpass-card-delete-dialog/masterpass-card-delete-dialog.controller.ts